export default __webpack_public_path__ + "static/media/broadcasting.628a713d.svg";